/**
 * Davetten gelen kullanıcının hesap adımından SONRA döneceği yol (CLOS-74 `[035]`).
 *
 * Kart, kapsamına "mevcut veya yeni hesapla eşleştirme ... ve sonuç yönlendirmesi"ni
 * açıkça alıyor. Dönüş yolu olmasaydı davetli, giriş ya da kayıt biter bitmez `/tenants`'a
 * düşer ve davetini kaybederdi; elindeki tek çare e-postaya dönüp bağlantıya yeniden
 * tıklamak olurdu.
 *
 * ### Neden serbest bir `returnTo` değil
 *
 * Hedef adres dışarıdan ALINMIYOR, yalnız token alınıyor ve yol burada `/davet` olarak
 * SABİT üretiliyor. Genel bir `?returnTo=<url>` parametresi açık yönlendirme (open
 * redirect) yüzeyi olurdu: saldırgan giriş bağlantısını kendi sitesine dönecek biçimde
 * hazırlayıp kullanıcıyı taşıyabilirdi. Buradaki biçimde taşınabilecek tek şey token'dır.
 *
 * Token'ın adres çubuğunda görünmesi yeni bir sızıntı açmıyor: kullanıcı zaten onu adres
 * çubuğunda taşıyan bir e-posta bağlantısıyla geldi.
 */
export function inviteReturnPath(search: string): string | null {
  const token = new URLSearchParams(search).get("davet");
  return token ? `/davet?token=${encodeURIComponent(token)}` : null;
}
